<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Support Document
    </div>
    <div class="enterprise-network_container_table">
      <el-table border :data="formData">
        <el-table-column
          label="Items"
          prop="items"
          min-width="219"
          show-overflow-tooltip
        >
          <template v-slot:default="{row}">
            {{ getItemName(row.typeNumber) }}
          </template>
        </el-table-column>
        <el-table-column
          label="File Name"
          prop="fileName"
          min-width="298"
          show-overflow-tooltip
        >
          <template v-slot:default="{row}">
            <span class="click-span" @click="handleOpenFile(row.fileUrl, row)">{{ row.fileName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Upload Datetime"
          prop="createTime"
          min-width="150"
          show-overflow-tooltip
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import APIS from "../../../../api/fileAxios/fileAxios";
import { recordUserAction } from "@/utils/recordUserAction.js"
export default {
  name: "enterpriseNetworkSupportDocumentDetail",
  props: {
    formData: {
      type: Array,
      default: () => ([])
    },
  },
  methods: {
    getItemName(typeNumber) {
      switch (typeNumber) {
        case 11:
          return "Business License";
        case 12:
          return "Business Plan";
        case 10:
          return "Contract Agreement";
        case 3:
          return "Authorization Certificate";
        case 1:
          return "Type of Contract";
        default:
          return "-";
      }
    },
    handleOpenFile(fileId, row) {
      if(row.typeNumber === 3){
        recordUserAction('electro_auth_download_event')
      }
      APIS.getAliOSSDownloadInfo(fileId)
        .then(res => {
          let { status, data } = res.data;
          if (Number(status) === 200) {
            window.open(data.fileInfo.url);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
  }
};
</script>

<style scoped>
.click-span {
  color: #2a82e4;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/supportDocument/supportDocumentDetail.vue